export default "__VITE_ASSET__f09efa12__"